import {
    ChangeDetectionStrategy,
    Component,
    signal,
    input,
    output,
    ViewChild,
    ViewEncapsulation,
    effect,
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';

@Component({
    selector: 'fi-filter-saved-filters-menu',
    templateUrl: './fi-filter-saved-filters-menu.component.html',
    styleUrls: ['./fi-filter-saved-filters-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-filter-saved-filters-menu' },
    standalone: false,
})
export class FiFilterSavedFiltersMenuComponent<T extends { Name: string }> {
    public savedFilters = input<T[]>([]);
    private _savedFiltersEffect = effect(() => {
        this.filteredSavedFilters.set(this.savedFilters());
    });
    public isFilterActionMenuAvailable = input<boolean>(true);
    public onSelectSavedFilter = output<T>();
    public onOpenRenameSavedFilterDialog = output<T>();
    public onOpenChangeSavedFilterDialog = output<T>();
    public onOpenDeleteSavedFilterDialog = output<T>();

    @ViewChild('savedFiltersMenu', { static: true }) savedFiltersMatMenu: MatMenu;

    protected filteredSavedFilters = signal<T[]>([]);
    protected savedFilterNameSearch: string;
    private readonly filterDelayMS: 500;
    private filterSavedFiltersTimeout: NodeJS.Timeout;

    protected filterSavedFiltersByName(): void {
        if (this.filterSavedFiltersTimeout) {
            clearTimeout(this.filterSavedFiltersTimeout);
        }

        this.filterSavedFiltersTimeout = setTimeout(() => {
            this.filteredSavedFilters.set(
                this.savedFilters().filter((savedFilter: T) => {
                    return savedFilter.Name.includes(this.savedFilterNameSearch);
                }),
            );
        }, this.filterDelayMS);
    }
}
